import '../styles/general.scss';
import '../styles/partials/product-categories.scss';
import '../styles/partials/menu-general.scss';
import '../styles/partials/menu-dropdown.scss';
import '../styles/partials/pagenumberer.scss';
import '../scripts/_common/tabs/tabs.module.js';
import '../scripts/_partials/cart/cart.module.js';
import '../scripts/_partials/catalog-filter/catalogFilter.module.js';